/**
 * Configuration flags go here
 */
module.exports = {
  webFonts: ['Open Sans:300,400,700', 'Roboto:300']
};
